module.exports = __webpack_public_path__ + "assets/img/saveIcon.bd2e29f1.svg";